<template>
  <div class="survey-page">
    <div class="survey-container">
      <h1>{{ surveyTitle }}</h1>
      <div class="divider"></div>

      <!-- 问卷题目区域 -->
      <div class="question-list">
        <div v-for="(question, index) in questionList" :key="index" class="question-item">
          <div class="question-title">
            <span class="question-num">{{ index + 1 }}.</span>
            <span>{{ question.title }}</span>
            <span v-if="question.required" class="required">*</span>
          </div>

          <!-- 单选题 -->
          <div v-if="question.type === 'single'" class="option-list">
            <label v-for="(option, optIndex) in question.options" :key="optIndex" class="option-item">
              <input
                  type="radio"
                  :name="'question_' + index"
                  :value="option"
                  v-model="question.answer"
              >
              <span>{{ option }}</span>
            </label>
          </div>

          <!-- 填空题 -->
          <div v-else-if="question.type === 'input'" class="input-box">
            <input
                type="text"
                v-model="question.answer"
                :placeholder="question.placeholder || '请输入你的答案'"
            >
          </div>

          <!-- 量表题 -->
          <div v-else-if="question.type === 'scale'" class="scale-list">
            <label v-for="(scale, scaleIndex) in question.scales" :key="scaleIndex" class="scale-item">
              <input
                  type="radio"
                  :name="'question_' + index"
                  :value="scale.value"
                  v-model="question.answer"
              >
              <span>{{ scale.label }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- 提交按钮 -->
      <div class="submit-wrap">
        <el-button type="primary" @click="submitSurvey" :loading="submitting">
          提交问卷
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
// ✅import 放到script标签最顶部
import { apiSurveySubmit, apiGetSurveyStatus } from '@/api/survey'

export default {
  name: 'FormSurvey',
  data() {
    return {
      submitting: false,
      // 前测问卷配置（来自你的Excel文件）
      preTestConfig: {
        title: '大语言模型辅助情景化临床思维测评问卷',
        questions: [
          {
            type: 'single',
            title: '[1基本信息]你的性别',
            required: true,
            options: ['男', '女'],
            answer: ''
          },
          {
            type: 'input',
            title: '[2基本信息]你的年龄（周岁）',
            required: true,
            placeholder: '请输入数字',
            answer: ''
          },
          {
            type: 'single',
            title: '[3基本信息]在学习本教学模块前，你是否接触过口腔颌面肿瘤或术后康复的理论/实践',
            required: true,
            options: ['从未接触', '仅听说过', '学过部分理论', '有过临床观察/实践'],
            answer: ''
          },
          {
            type: 'scale',
            title: '[4基本信息]你对大语言模型工具（如ChatGPT、豆包、DeepSeek、Kimmi等）的熟悉程度',
            required: true,
            scales: [
              { value: 1, label: '极不熟悉' },
              { value: 2, label: '不太熟悉' },
              { value: 3, label: '一般' },
              { value: 4, label: '比较熟悉' },
              { value: 5, label: '极其熟悉' }
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[5基本信息]你在日常学习中使用大语言模型的频率',
            required: true,
            options: ['从未使用', '偶尔（每月1‑2次）', '经常（每周1‑3次）', '频繁（几乎每天）'],
            answer: ''
          },
          {
            type: 'single',
            title: '[1客观测评]（案例1‑吞咽障碍）67岁男性，舌癌切除+前臂皮瓣修复术后2周，气管切开套管在位，鼻饲管进食，评估其吞咽功能最首选的检查是？',
            required: true,
            options: [
              'A. 床旁洼田饮水试验',
              'B. 纤维内镜吞咽评估',
              'C. 食管造影',
              'D. 询问主管医生后直接拔除鼻饲管'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[2客观测评]（案例1续）若患者出现唾液增多、咳嗽无力，你最应警惕的风险是：',
            required: true,
            options: [
              'A. 皮瓣坏死',
              'B. 吸入性肺炎',
              'C. 伤口感染',
              'D. 心理焦虑'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[3客观测评]55岁女性颊癌根治+择区颈部淋巴结清扫术后，主诉右肩活动受限，手无法梳头。你初步判断最可能损伤的神经是：',
            required: true,
            options: [
              'A. 面神经下颌缘支',
              'B. 副神经',
              'C. 舌下神经',
              'D. 臂丛上干'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[4客观测评]评估口腔癌术后吞咽安全性的金标准方法是：',
            required: true,
            options: [
              'A. 反复唾液吞咽测试',
              'B. 床边饮水试验',
              'C. 电视荧光吞咽造影 (VFSS)',
              'D. 纤维内镜吞咽评估 (FEES)'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[5客观测评]口腔癌术后急性期，患者疼痛最主要的来源是:',
            required: true,
            options: [
              'A. 胃肠道痉挛',
              'B. 手术创面软组织损伤、颈部清扫后组织牵拉',
              'C. 颅内神经病变',
              'D. 心理焦虑产生躯体化疼痛'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[6客观测评]口腔癌术后急性期口腔卫生维护，说法正确的是',
            required: true,
            options: [
              'A. 术后立即使用硬毛牙刷大力刷洗术区',
              'B. 可采用温和含漱方式清洁，避免损伤手术创面',
              'C. 术后 1 周内完全不能做任何口腔清洁',
              'D. 使用高浓度酒精漱口消毒'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[7客观测评]舌癌术后亚急性期吞咽障碍，口腔期障碍主要原因是：',
            required: true,
            options: [
              'A. 舌体切除后舌搅拌、推送食团功能受损',
              'B. 环咽肌完全不开放',
              'C. 声带完全麻痹',
              'D. 食管狭窄'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[8客观测评]颈部淋巴结清扫术后患者发生张口受限，主要诱因是:',
            required: true,
            options: [
              'A. 大脑中枢神经损伤',
              'B. 颈部术区瘢痕挛缩、长期制动、术区牵拉痛',
              'C. 牙齿全部脱落',
              'D. 颞下颌关节直接骨折断裂'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[9客观测评]关于口腔癌术后居家康复依从性阻碍，属于生理层面阻碍的是：',
            required: true,
            options: [
              'A. 自卑不愿社交',
              'B. 训练牵拉疼痛、身体疲劳、味觉改变食欲下降',
              'C. 独居缺少他人监督',
              'D. 训练内容枯燥'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[10客观测评]口腔癌术后长期随访监测，需要重点监测的内容不包括：',
            required: true,
            options: [
              'A. 肿瘤复发相关体征',
              'B. 张口、吞咽、语音功能是否倒退',
              'C. 居家训练执行情况、营养及心理状态',
              'D. 患者的既往中学学习成绩'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[1临床思维自评]我能从繁杂的病例信息中快速识别关键问题',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[2临床思维自评]面对不完整的临床信息，我知道需要追问哪些方面',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[3临床思维自评]我能有条理地解释我的临床推理步骤',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[4临床思维自评]遇到治疗矛盾时，我会主动寻求更多资料并重新评估',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[5临床思维自评]我能够根据患者的个体情况调整康复方案',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          }
        ]
      },
      // 后测问卷配置（对应你的调查问卷2，可自行补充题目）
      postTestConfig: {
        title: '课程学习效果测评问卷',
        questions: [
          {
            type: 'single',
            title: '[1教学满意度调查]这种教学方法增强了我对口腔癌术后康复临床思维的理解',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'],
            answer: ''
          },
          {
            type: 'single',
            title: '[2教学满意度调查]本次教学中使用的临床情景清晰且呈现良好',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'],
            answer: ''
          },
          {
            type: 'single',
            title: '[3教学满意度调查]在学习活动中，我感到投入并积极参与',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[4教学满意度调查]这种教学方式有助于培养我的临床推理能力',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[5教学满意度调查]总的来说，我对本次教学感到满意',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[1语言模型可行性]我发现基于大语言模型的互动平台易于使用',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[2语言模型可行性]平台的回答对我的学习有相关性和帮助。',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[3语言模型可行性]我觉得平台界面设计友好。',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[4语言模型可行性]平台响应速度满足学习需求',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'single',
            title: '[5语言模型可行性]我希望在今后的临床学习中能使用类似的大语言模型工具。',
            required: true,
            options: [
              '1 = 非常不同意',
              '2 = 不太同意',
              '3 = 一般 / 中立',
              '4 = 比较同意',
              '5 = 非常同意'
            ],
            answer: ''
          },
          {
            type: 'input',
            title: '你对本课程的改进建议',
            required: false,
            placeholder: '请输入你的建议',
            answer: ''
          }
        ]
      }
    }
  },
  computed: {
    // 根据路由路径，动态切换问卷配置
    isPreTest() {
      // ✅全部使用英文普通短横杠 "-"
      return this.$route.path === '/survey/pre-test'
    },
    surveyTitle() {
      return this.isPreTest ? this.preTestConfig.title : this.postTestConfig.title
    },
    questionList() {
      return this.isPreTest ? this.preTestConfig.questions : this.postTestConfig.questions
    }
  },
  methods: {
    async submitSurvey() {
      // 校验必填题
      const requiredQuestions = this.questionList.filter(q => q.required)
      const unanswered = requiredQuestions.filter(q => !q.answer)
      if (unanswered.length > 0) {
        this.$message.error('请完成所有必填题目')
        return
      }

      this.submitting = true
      try {
        // 组装答题数据，把questionList里面每道题的题目+用户答案保存
        const answerData = this.questionList.map(item => ({
          title: item.title,
          answer: item.answer
        }))

        const surveyType = this.isPreTest ? "pre" : "post"

        // 调用后端真实提交接口
        await apiSurveySubmit({
          survey_type: surveyType,
          content: JSON.stringify(answerData)
        })

        // ✅更新vuex状态，不再操作localStorage
        // 提交成功后，从后端拉取数据库最新状态，同步到vuex
        const resStatus = await apiGetSurveyStatus()
        this.$store.commit("user/SET_SURVEY_STATUS", resStatus.data)

// 根据问卷类型给出提示
        const msg = this.isPreTest
            ? '前测问卷提交成功，欢迎进入课程学习'
            : '后测问卷提交成功，感谢你的参与'
        this.$message.success(msg)

        this.$router.push('/home')
      } catch (err) {
        console.error(err)
        this.$message.error('问卷提交失败，请重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.survey-page {
  padding: 24px;
  background: #f5f7fa;
  min-height: 100vh;
}
.survey-container {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.divider {
  height: 2px;
  background: #eee;
  margin: 16px 0 24px;
}
.question-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.question-item {
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 6px;
}
.question-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  line-height: 1.6;
}
.question-num {
  color: #409eff;
  font-weight: 600;
}
.required {
  color: #f56c6c;
  margin-left: 4px;
}
.option-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.option-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 15px;
}
.input-box input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 15px;
}
.scale-list {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.scale-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 14px;
}
.submit-wrap {
  margin-top: 32px;
  text-align: center;
}
</style>